/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'building/frame_orbital_hidden': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<path pid="0" d="M1 17H0v15h15v-1H1zM31 31H17v1h15V17h-1zM17 0v1h14v14h1V0zM1 1h14V0H0v15h1zM21 8h2v1h-2zM23 9h1v2h-1zM21 10h1v1h-1zM21 13h1v1h-1zM23 15h1v-3h-1v2h-1v1zM23 18h1v5h-1zM22 21v-3h-2v1h1v2h-2v-1h1v-1h-1v-1h-1v4h4zM21 23h2v1h-2zM17 22v2h3v-1h-2v-1zM9 23h2v1H9zM8 21h1v2H8zM9 8h2v1H9zM8 9h1v5H8zM9 17H8v3h1v-2h1v-1zM10 21h1v1h-1zM10 18h1v1h-1zM15 8h-3v1h2v1h1zM16 13h2v1h-2zM14 18h2v1h-2zM15 17v-1h1v-1h-2v1h-1v-1h-2v2h2v1h1v-1zM17 17h1v-1h1v1h2v-2h-2v-1h-1v1h-1v1h-1v1zM15 11h1v2h-1zM16 19h1v2h-1zM19 11h-1v-1h-1v2h2v1h2v-2h-1V8h-3v1h2zM16 9h1v1h-1zM13 21h1v1h1v-2h-2v-1h-2v2h1v3h3v-1h-2zM15 22h1v1h-1zM14 14v-4h-4v4h2v-1h-1v-2h2v1h-1v1h1v1z"/>'
  }
})
